import { createApiRef } from '@backstage/core-plugin-api';

const DEFAULT_PROXY_PATH = "/quay/api";
const quayApiRef = createApiRef({
  id: "plugin.quay.service"
});
class QuayApiClient {
  // @ts-ignore
  discoveryApi;
  configApi;
  identityApi;
  constructor(options) {
    this.discoveryApi = options.discoveryApi;
    this.configApi = options.configApi;
    this.identityApi = options.identityApi;
  }
  async getBaseUrl() {
    const proxyPath = this.configApi.getOptionalString("quay.proxyPath") || DEFAULT_PROXY_PATH;
    return `${await this.discoveryApi.getBaseUrl("proxy")}${proxyPath}`;
  }
  async fetcher(url) {
    const { token: idToken } = await this.identityApi.getCredentials();
    const response = await fetch(url, {
      headers: {
        "Content-Type": "application/json",
        ...idToken && { Authorization: `Bearer ${idToken}` }
      }
    });
    if (!response.ok) {
      throw new Error(
        `failed to fetch data, status ${response.status}: ${response.statusText}`
      );
    }
    return await response.json();
  }
  encodeGetParams(params) {
    return Object.keys(params).filter((key) => typeof params[key] !== "undefined").map(
      (k) => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`
    ).join("&");
  }
  async getTags(org, repo, page, limit, specifcTag) {
    const proxyUrl = await this.getBaseUrl();
    const params = this.encodeGetParams({
      limit,
      page,
      onlyActiveTags: true,
      specifcTag
    });
    return await this.fetcher(
      `${proxyUrl}/api/v1/repository/${org}/${repo}/tag/?${params}`
    );
  }
  async getLabels(org, repo, digest) {
    const proxyUrl = await this.getBaseUrl();
    return await this.fetcher(
      `${proxyUrl}/api/v1/repository/${org}/${repo}/manifest/${digest}/labels`
    );
  }
  async getManifestByDigest(org, repo, digest) {
    const proxyUrl = await this.getBaseUrl();
    return await this.fetcher(
      `${proxyUrl}/api/v1/repository/${org}/${repo}/manifest/${digest}`
    );
  }
  async getSecurityDetails(org, repo, digest) {
    const proxyUrl = await this.getBaseUrl();
    const params = this.encodeGetParams({
      vulnerabilities: true
    });
    return await this.fetcher(
      `${proxyUrl}/api/v1/repository/${org}/${repo}/manifest/${digest}/security?${params}`
    );
  }
}

export { QuayApiClient, quayApiRef };
//# sourceMappingURL=index.esm.js.map
